import { DatePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideConfig, provideFeatureToggles, WithCredentialsInterceptor } from '@spartacus/core';
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { CookieModule, CookieService } from 'ngx-cookie';
import { NewsService } from '../service/news/news.service';
import { CustomLoginFormComponentService } from '../service/user/custom-login-form-component.service';

@NgModule({
  declarations: [],
  imports: [CookieModule.forRoot()],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    DatePipe,
    TitleCasePipe,
    NewsService,
    CookieService,
    CustomLoginFormComponentService,
    WithCredentialsInterceptor,
    provideFeatureToggles({
      enableReadDomainValuesOnDemand: false,
      storeFinderFacadeCleanup: false,
      defaultProductPageRouteAllowsNoProductName: false,
      reserveHorizontalSpaceStarRating: false,
      topProgressBarUseTransformAnimation: false,
      readMoreDirective: false,
      productReviewCharactersLeft: false,
      consistentSizeProductCards: false,
      disableCxPageSlotMarginAnimation: false,
      productCarouselScrolling: false,
      createMediaPreconnectLink: false,
      unifiedDefaultHeaderSlotsAcrossBreakpoints: false,
      reserveSpaceForImagesOnPdpAndPlp: false,
      lazyLoadImagesByDefault: false,
      defaultLayoutConfigWithoutPageFold: false,
    }),
  ],
})
export class SpartacusConfigurationModule {}
